import React from 'react';
import { urls } from '..';
import { useFavorites } from './FavoritesProvider';
import { byDesc } from '../data/utils/byDesc';
import { getConfiguration } from '../data/utils/configuration';
import { usePrematchData } from '../prematch/PrematchDataProvider';
import HighlightedTournaments from '../prematch/HighlightedTournaments';
import { useIsDateSection } from './IsDateSectionProvider';
import OpenSelectionsButton from './OpenSelectionsButton';
import TournamentCheckbox from './TournamentCheckbox';
import TournamentsSelectionsProvider from './TournamentsSelectionsProvider';
import useIsLiveSection from './useIsLiveSection';
import { useUserSettings } from './UserSettingsProvider';
import CategoryCheckbox from './CategoryCheckbox';
import RankingsButton from './RankingsButton';
import FavoriteButton from './FavoriteButton';
import XRouterLink from './seo/xrouter/XRouterLink';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import TournamentLiveBadge from '../prematch/TournamentLiveBadge';
import { removeMultipleSlashes } from '../data/sport-utils';
import { getLabel } from '../data/labels';

export function Tournament(props) {
    const prematchData = usePrematchData();
    const isDateSection = useIsDateSection();
    const isLiveSection = useIsLiveSection();

    const t = props.data;
    const category = prematchData.sportById[t.sportRef].categoryById[t.categoryRef];
    const id = isDateSection ? t.id : t.uniqueId;

    function getUrl() {
        let url, isrelative = false;
        if (isLiveSection) {
            url = `${urls.base}/${urls.live.base}/${urls.live.torneo}/${id}`;
        } else if (isDateSection) {
            url = `${id}`;
            isrelative = true;
        } else {
            url = `${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/${id}`;
        }

        return [url, isrelative]
    }

    /*function openTournament(e) {
        e.stopPropagation();
        navigate(getUrl());
    }*/

    const [url, isrelative] = getUrl();

    return (
        <>
            <div className="xs_tournamentItem h-[50px] grid grid-cols-10 items-center bg-cs1 border-b border-b-cs7">
                {/* <div className={"col-start-1 col-end-2 justify-self-center inline-block border border-cs7 w-[16px] h-[16px] " + category?.categoryIcon ?? ''}></div> */}
                <FavoriteButton id={t.uniqueId || t.id} />
                {props.showCategory ?
                    <XRouterLink isrelative={isrelative} data={t} to={url} className="col-start-2 col-end-9 px-1 grid grid-rows-2" >
                        <span className="font-bold text-xs text-cs9 uppercase truncate">{category?.descrizione ?? ''}</span>
                        <div className="flex items-center truncate">
                            <span className="font-bold text-sm text-cs10 truncate mr-auto">{t.descrizione || t.desc}</span>
                            <TournamentLiveBadge uniqueId={t.uniqueId} />
                        </div>
                    </XRouterLink>
                    :
                    <XRouterLink isrelative={isrelative} data={t} to={url} className="col-start-2 col-end-9 px-1" >
                        <div className="flex items-center truncate">
                            <span className="font-bold text-sm text-cs10 truncate mr-auto">{t.descrizione || t.desc}</span>
                            <TournamentLiveBadge uniqueId={t.uniqueId} />
                        </div>
                    </XRouterLink>
                }
                {/* <div className="col-start-7 col-end-9 flex items-center justify-center">
                    {t.classifica &&
                        <RankingsButton classifica={t.classifica} sportId={t.sportRef} />
                    }
                </div> */}
                <div className="col-start-9 col-end-10 flex items-center justify-center">
                    {props.showCheckbox &&
                        <TournamentCheckbox id={id} />
                    }
                </div>
                <div className="col-start-10 col-end-11 flex items-center justify-center">
                    <div className="min-h-[20px] min-w-[28px] w-fit px-1 flex items-center justify-center bg-cs4 rounded-md">
                        <span className="leading-[.6rem] font-medium text-xxs text-cs1">{t.eventsCount ? t.eventsCount : t.matches.length}</span>
                    </div>
                </div>
            </div>
        </>
    );
}

export function FavoriteTournament(props) {
    const prematchData = usePrematchData();
    const isDateSection = useIsDateSection();
    const isLiveSection = useIsLiveSection();

    const t = props.data;
    const category = prematchData.sportById[t.sportRef].categoryById[t.categoryRef];
    const id = isDateSection ? t.id : t.uniqueId;

    function getUrl() {
        let url, isrelative = false;
        if (isLiveSection) {
            url = `${urls.base}/${urls.live.base}/${urls.live.torneo}/${id}`;
        } else if (isDateSection) {
            url = `${id}`;
            isrelative = true;
        } else {
            url = `${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/${id}`;
        }

        return [url, isrelative]
    }

    /*function openTournament(e) {
        e.stopPropagation();
        navigate(getUrl());
    }*/

    const [url, isrelative] = getUrl();
    const conf = getConfiguration();

    return (
        <>
            <div className="h-[50px] grid grid-cols-10 items-center bg-cs1 border-b border-b-cs7">
                <div className="col-start-1 col-end-2 flx items-center justify-center">
                    <FavoriteButton id={t.uniqueId} />
                </div>
                <div className={"col-start-2 col-end-3 justify-self-center inline-block border border-cs7 w-[16px] h-[16px] " + category?.categoryIcon ?? ''}></div>
                {props.showCategory ?
                    <XRouterLink isrelative={isrelative} data={t} to={url} className="col-start-3 col-end-8 px-1 grid grid-rows-2" >
                        <span className="font-bold text-xs text-cs9 uppercase truncate">{category?.descrizione ?? ''}</span>
                        <div className="flex items-center truncate">
                            <span className="font-bold text-sm text-cs10 truncate mr-auto">{t.descrizione || t.desc}</span>
                            <TournamentLiveBadge uniqueId={t.uniqueId} />
                        </div>
                    </XRouterLink>
                    :
                    <XRouterLink isrelative={isrelative} data={t} to={url} className="col-start-3 col-end-8 px-1" >
                        <div className="flex items-center truncate">
                            <span className="font-bold text-sm text-cs10 truncate mr-auto">{t.descrizione || t.desc}</span>
                            <TournamentLiveBadge uniqueId={t.uniqueId} />
                        </div>
                    </XRouterLink>
                }
                <div className="col-start-8 col-end-9 flex items-center justify-center">
                    {t.classifica &&
                        <RankingsButton classifica={t.classifica} sportId={t.sportRef} />
                    }
                </div>
                <div className="col-start-9 col-end-10 flex items-center justify-center">
                    {(props.showCheckbox || conf.iwh) &&
                        <TournamentCheckbox id={id} />
                    }
                </div>
                <div className="col-start-10 col-end-11 flex items-center justify-center">
                    <div className="min-h-[20px] min-w-[28px] w-fit px-1 flex items-center justify-center bg-cs4 rounded-md">
                        <span className="leading-[.6rem] font-medium text-xxs text-cs1">{category?.tournamentsCount ?? ''}</span>
                    </div>
                </div>
            </div>
        </>
    );
}

function FavoriteTournaments(props) {
    const favorites = useFavorites();
    const favoritesSet = new Set(Object.keys(favorites));

    const favoriteTournaments = [];
    props.categories.forEach(c =>
        c.tournaments.forEach(t => {
            if (favoritesSet.has(t.uniqueId)) {
                favoriteTournaments.push(<Tournament key={t.uniqueId} data={t} showCategory={true} showCheckbox={true} />);
            }
        })
    );

    if (favoriteTournaments.length === 0) {
        return null;
    }

    return (
        <>
            <div className="px-2 py-1 bg-cs15 text-cs10 font-medium text-xs uppercase">{getLabel('navbar_buttons.favorite_tournaments')}</div>
            {favoriteTournaments}
        </>
    );
}

export default function TournamentsMenu(props) {
    const navigate = useNavigate();
    const params = useParams();
    const userSettings = useUserSettings();
    const isDateSection = useIsDateSection();
    const isLiveSection = useIsLiveSection();

    function handleClick(tournaments) {
        const ids = tournaments.map(t => t.uniqueId || t.id).join(',');
        if (isLiveSection) {
            navigate(removeMultipleSlashes(`${urls.base}/${urls.live.base}/${urls.live.torneo}/${ids}`));
        } else if (isDateSection) {
            navigate(removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${params.date}/${params.sportId}/${params.aggId}/${ids}`));
        } else {
            navigate(removeMultipleSlashes(`${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/${ids}`));
        }
    }

    let categories = props.categories;

    if (userSettings.sortCategoriesByDesc) {
        categories = Array.from(props.categories).sort(byDesc);
        // const tournaments = [];
        // props.categories.map(c =>
        //     c.tournaments.map(t => tournaments.push(t))
        // );
        // tournaments.sort(byDesc);

        // return (
        //     <TournamentsSelectionsProvider>
        //         <div className="h-full">
        //             <FavoriteTournaments categories={props.categories} />
        //             <div className="px-2 py-1 bg-cs7 text-cs6 font-medium text-xs uppercase">Tornei [A-Z]</div>
        //             {tournaments.map(t => 
        //                 <Tournament key={t.uniqueId} data={t} showCategory={true} showCheckbox={true} />
        //             )}
        //             <OpenSelectionsButton />
        //         </div>
        //     </TournamentsSelectionsProvider>
        // );
    }

    return (
        <TournamentsSelectionsProvider>
            {userSettings.showHighlightedTournaments &&
                <HighlightedTournaments sportId={categories[0].sportRef} categories={props.categories} />
            }
            {categories.map(c => {
                const colStartDesc = c.categoryIcon ? 2 : 1;
                return (
                    <React.Fragment key={c.id}>
                        <div className="xs_categoryHeader grid grid-cols-10 py-1 bg-cs7 text-cs6" onClick={() => handleClick(c.tournaments)}>
                            <>{c.categoryIcon &&
                                <div className={`col-start-1 col-end-2 justify-self-center inline-block border border-cs7 w-[16px] h-[16px]  ${c?.categoryIcon ?? ''}`}></div>
                            }
                            </>
                            <div className={`col-start-${colStartDesc} col-end-9 pl-2 flex items-center font-medium text-xs uppercase`}>{c.descrizione}</div>
                            <div className="col-start-9 col-end-10 flex items-center justify-center">
                                <CategoryCheckbox tournaments={c.tournaments} useUniqueId={!isDateSection} />
                            </div>
                        </div>
                        {c.tournaments.map(t =>
                            <Tournament key={t.uniqueId} data={t} showCheckbox={true} />
                        )}
                    </React.Fragment>
                );
            })}
            <OpenSelectionsButton />
        </TournamentsSelectionsProvider>
    );
}
